import { ReactElement } from "react";
import Head from "next/head";
import { MainLayout } from "@/containers/layout/KoachLayout";
import routes from "@/constants/routes";
import Image from "next/image";
import Link from "next/link";

const DeleteAccount = () => {
  return (
    <>
      <Head>
        <title>Delete Account | Klink</title>
        <link rel="canonical" href="https://www.klink-app.com/delete-account" />
        <meta
          name="description"
          content="Securely request the deletion of your account and all associated data with our simple online form. Protect your privacy and take control of your personal information."
        />
        <meta
          name="twitter:card"
          content="Securely request the deletion of your account and all associated data with our simple online form. Protect your privacy and take control of your personal information."
          key="twcard"
        />
        <meta name="twitter:creator" content="klink_app" key="twhandle" />
        <meta
          property="og:url"
          content="https://www.klink-app.com/delete-account"
          key="ogurl"
        />
        <meta
          property="og:image"
          content="/meta-opengraph-landing.png"
          key="ogimage"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Klink" key="ogsitename" />
        <meta
          property="og:title"
          content="Delete Account | Klink"
          key="ogtitle"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_GB" />
        <meta
          property="og:description"
          content="Securely request the deletion of your account and all associated data with our simple online form. Protect your privacy and take control of your personal information."
          key="ogdesc"
        />
      </Head>

      <div className="px-5 lg:px-11 xl:px-32 my-14">
        <div className="font-medium cursor-pointer mb-4 lg:mb-6">
          <Link href={routes.home}>
            <div className="flex items-center justify-start gap-3 font-bold text-magenta">
              <Image
                className="rotate-180"
                src="/koach/icons/arrow-right.svg"
                width={14}
                height={14}
                alt="chevron"
              />
              BACK
            </div>
          </Link>
        </div>
        <div className="xl:h-20 text-center mb-10 md:mb-14 flex flex-col gap-3">
          <h1 className="font-bold text-[32px] md:text-[48px] xl:text-[64px]">
            Delete Account
          </h1>
          <h2 className="text-2xl md:text-3xl font-normal">
            Submit a request to delete your Klink account and all associated
            data. <br />
            <br /> Once processed, this cannot be reversed.
          </h2>
        </div>

        <div className="flex items-center justify-center">
          <div data-tf-live="01HXBYM1H550YKVVPT9QR3YJF5"></div>
          <script src="//embed.typeform.com/next/embed.js"></script>
        </div>
      </div>
    </>
  );
};

DeleteAccount.getLayout = function getLayout(page: ReactElement) {
  return <MainLayout>{page}</MainLayout>;
};

export default DeleteAccount;
